module.exports = __webpack_public_path__ + "static/img/wxd.abd6014.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/doctor/wxd.jpg
// module id = IE2U
// module chunks = 1